<template>
    <section class="slice slice-quote">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 120">
            <path
                d="M 5.127 101.506 C 8.546 102.366 11.823 102.796 14.956 102.796 C 25.781 102.796 34.755 98.351 41.877 89.463 C 49.283 80.287 52.845 68.961 52.56 55.483 C 46.862 58.065 41.592 59.355 36.749 59.355 C 28.488 59.355 21.508 56.487 15.81 50.753 C 10.398 45.018 7.692 38.136 7.692 30.107 C 7.692 21.219 10.54 14.05 16.238 8.602 C 21.936 2.867 28.915 0 37.176 0 C 47.432 0 55.551 4.301 61.533 12.904 C 67.516 21.219 70.508 33.261 70.508 49.032 C 70.508 70.538 65.379 87.742 55.124 100.645 C 45.153 113.548 32.049 120 15.81 120 C 11.537 120 6.267 119.284 0 117.85 L 5.127 101.506 Z M 84.609 101.506 C 88.027 102.366 91.303 102.796 94.437 102.796 C 105.263 102.796 114.378 98.351 121.786 89.463 C 129.193 80.287 132.753 68.961 132.469 55.483 C 127.056 58.065 121.786 59.355 116.657 59.355 C 108.396 59.355 101.417 56.487 95.719 50.753 C 90.307 45.018 87.6 38.136 87.6 30.107 C 87.6 21.219 90.449 14.05 96.147 8.602 C 101.844 2.867 108.823 0 117.085 0 C 127.056 0 135.032 4.301 141.015 12.904 C 146.998 21.219 149.988 33.261 149.988 49.032 C 150.274 70.538 145.288 87.742 135.032 100.645 C 125.062 113.548 111.957 120 95.719 120 C 91.446 120 86.176 119.284 79.908 117.85 L 84.609 101.506 Z"
            ></path>
        </svg>
        <blockquote>
            <p>{{ content }}</p>
        </blockquote>
        <div class="slice-quote__author">
            <PrismicImage v-if="slice.primary.authorImage.url" :field="slice.primary.authorImage" />
            <div>
                <PrismicRichText :field="slice.primary.author" class="slice-quote__author-name" />
                <p v-if="slice.primary.authorJob && slice.primary.authorJob !== ''" class="slice-quote__author-job">{{ slice.primary.authorJob }}</p>
            </div>
        </div>
        <PrismicImage :field="slice.primary.logo" class="slice-quote__logo" />
    </section>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {asText} from '@prismicio/helpers';
    import {getSliceComponentProps, PrismicImage, PrismicRichText} from '@prismicio/vue';
    import type {QuoteSlice} from '@prismicio-types';

    const props = defineProps(getSliceComponentProps<QuoteSlice>());

    const content = computed(() => asText(props.slice.primary.content) + '"');
</script>

<style lang="scss">
    @use '~/assets/styles/variables' as *;

    .slice-quote {
        position: relative;
        margin-top: var(--joy-core-spacing-10);
        padding: var(--joy-core-spacing-12) 0 var(--joy-core-spacing-9) var(--joy-core-spacing-10);

        @include content-width($article-max-width);

        svg {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 150px;
            height: 120px;
            transform: rotate(180deg);

            path {
                fill: var(--joy-color-brand-primary-30);
            }
        }

        a {
            text-decoration: underline var(--joy-color-neutral-0);

            &:hover {
                opacity: 0.8;
            }
        }

        blockquote {
            position: relative;
            margin: var(--joy-core-spacing-6) 0 var(--joy-core-spacing-7);

            p {
                font-size: var(--joy-font-size-primary-800);
                font-family: var(--joy-font-family-title) !important;
                line-height: var(--joy-core-line-height-small);
            }
        }

        &__author {
            display: flex;
            align-items: center;
            gap: var(--joy-core-spacing-3);

            img {
                height: 65px;
                width: 65px;
                border-radius: 48px;
                aspect-ratio: 1 / 1;
                object-fit: cover;
            }

            &__author-name * {
                font-size: var(--joy-font-size-primary-600);
                font-family: var(--joy-font-family-title) !important;
            }

            &__author-job {
                font-size: var(--joy-font-size-primary-300);
            }
        }

        &__logo {
            height: 20px;
            margin-left: 60px;
            width: auto;
            margin-top: var(--joy-core-spacing-2);
        }

        /* Themes */
        .resource-page--default & {
            svg path {
                fill: var(--joy-color-brand-primary-30);
            }
        }

        .resource-page--corporate & {
            svg path {
                fill: var(--joy-color-primary-30);
            }
        }

        .resource-page--strategy & {
            svg path {
                fill: var(--joy-color-secondary-30);
                opacity: 0.5;
            }
        }
    }
</style>
